module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "fs",
    attrs: {
      "id": "page028"
    }
  }, [_c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_1"
    }
  }, [_vm._v("FROMAGE FRAIS")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_2"
    }
  }, [_vm._v("TIME REQUIRED:")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_3"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ecause this fresh")]), _vm._v(" cheese has a very neutral flavour, it can be")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_4"
    }
  }, [_vm._v("30 minutes")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_5"
    }
  }, [_vm._v("used as a filling for different tarts.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_6"
    }
  }, [_vm._v("1 litre soya milk")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_7"
    }
  }, [_vm._v("1.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_7a"
    }
  }, [_c('span', {
    staticClass: "page028_7a"
  }, [_vm._v(" Combine the soya milk with the apple cider vinegar and lemon")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_8"
    }
  }, [_vm._v("3 tsp apple cider vinegar")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_9"
    }
  }, [_vm._v("juice in a pan and bring to the boil. Lower the heat and simmer for")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_10"
    }
  }, [_vm._v("3 tsp lemon juice")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_11"
    }
  }, [_vm._v("about 10 minutes, stirring constantly, until the mixture curdles.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_12"
    }
  }, [_vm._v("2.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_12a"
    }
  }, [_c('span', {
    staticClass: "page028_12a"
  }, [_vm._v("Pour it into a large sieve lined with a cloth, and then twist the")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_13"
    }
  }, [_vm._v("Salt, pepper")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_14"
    }
  }, [_vm._v("ends of the cloth together. Keep squeezing the contents well until")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_15"
    }
  }, [_vm._v("Vegan cream (optional)")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_16"
    }
  }, [_vm._v("you’re left with a solid mass inside the cloth. Transfer the cheese")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_17"
    }
  }, [_vm._v("to a bowl and season with salt and pepper. Mix in a little vegan")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_18"
    }
  }, [_vm._v("cream, if desired.")]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_19"
    }
  }, [_vm._v("B"), _c('span', {
    staticClass: "pagen"
  }, [_vm._v("asics")])]), _vm._v(" "), _c('div', {
    staticClass: "jstfy",
    attrs: {
      "id": "page028_0"
    }
  }, [_vm._v("28")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60882eb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page_028.vue
// module id = 138
// module chunks = 0